class Token {

    static decode(token = '..') {
        const spl = token.split('.');
        // const spl = token ? token.split('.') : this.token.split('.');
        const body = spl[1];

        if (!body)
            return this.emptyToken();

        try {
            const buff = new Buffer(body, 'base64');
            const jsonStr = buff.toString('ascii');


            return JSON.parse(jsonStr);
        } catch (e) {
            // console.log('error in decoding token', e);
            return this.emptyToken();
        }
    }

    static emptyToken() {
        return {orgId: null, exp: null, name: null}
    }

}

module.exports = Token;



// WEBPACK FOOTER //
// ./src/util/token.js